
import { View, Text, TouchableOpacity, ImageBackground, SafeAreaView, ScrollView, Dimensions, TextInput, FlatList, Modal, Image } from 'react-native'
import React from 'react';
import { useState, useEffect } from 'react';
import MyStyles from '../StyleSheets';
import {Ionicons} from '@expo/vector-icons';
import DatePicker from 'react-datepicker';
import {Calendar, LocaleConfig} from 'react-native-calendars';
import MyStyles2 from '../StyleSheetDesktop';
import moment from 'moment'

export default function Hoho() {

       /* #################   O F F I C I A L   H E X   C O L O R S #################### */

       let ORANGE = '#FF6600';
       let LIGHTBLUE  = '#00B4FF';
       let DARKBLUE = '#393BB2';
       let YELLOW = '#fff605';

  let normalColor = '#d4d4d4';
  let pressedColor = '#e9e9e9';
  let normalColorAirport = '#caa347';
  let pressedColorAirport = '#edddb8';
  let fullWidth = 800;
  let textColor = 'gray';
  let iconColor = 'white';
 
  let rowHeight = 45;
  let dateFlag = 0;
  let borderShade = 'gray';

  let fontSizeNormalMobile = 14;
  let fontSizeMediumMobile = 17;
  let fontSizeLargeMobile = 20;
  let fontSizeXSmallMobile = 13;
  let fontSizeNormalDesktop = 17;
  let fontSizeMediumDesktop = 20;
  let fontSizeLargeDesktop = 30;

  const [SID, setSID] = useState('');
  const [bookingID, setBookingID] = useState(''); 
  const [errorPrompt, setErrorPrompt] = useState('Please select Arrival and/or Departure dates to begin.');
  let today = new Date();
  let dateToday = today.getFullYear()+"-"+ parseInt(today.getMonth()+1) +"-"+today.getDate();
  let todayPlus24H = new Date(today.setHours(today.getHours() + 24))
  let dateTodayPlus24H = todayPlus24H.getFullYear()+"-"+ parseInt(todayPlus24H.getMonth()+1) +"-"+todayPlus24H.getDate();
  const [airportFlag, setAirportFlag] = useState(2); /* 2 = Caticlan, 1 = Kalibo */
  const [originID, setOriginID] = useState('2'); /* 2 = Caticlan, 1 = Kalibo */
  const [tx, setTx] = useState('');
  const [width, setWidth] = useState(Dimensions.get('window').width)
  const [height, setHeight] = useState(Dimensions.get('window').height);
  const [margin, setMargin] = useState(0);
  const [rowResponsive, setRowResponsive] = useState('row');
  const [scale, setScale] = useState(1);
  const [divider, setDivider] = useState(1);
  const [heightScale, setHeightScale] = useState(1);
  const [checkOutFlag, setCheckOutFlag] = useState(0);
 
  const [adonIndent, setAdonIndent] = useState(0);

  const [computeHOHO1, setComputeHOHO1] = useState(0);
  const [computeHOHO2, setComputeHOHO2] = useState(0);
  const [computeHOHO3, setComputeHOHO3] = useState(0);

  const [countHOHO1, setCountHOHO1] = useState(0);
  const [countHOHO2, setCountHOHO2] = useState(0);
  const [countHOHO3, setCountHOHO3] = useState(0);

  let priceHOHO1 = 200
  let priceHOHO2 = 300
  let priceHOHO3 = 400

  let priceIDHOHO1 = '85'
  let priceIDHOHO2 = '86'
  let priceIDHOHO3 = '87'

  const [dimension, setDimension] = useState(
    {
        winwidth :window.innerWidth,
        winheight : window.innerHeight,
    }
)

const updateDimension = () => {
    setDimension(
        {
            winwidth :window.innerWidth,
            winheight : window.innerHeight,
        }
    )
    setWidth(dimension.winwidth);
    setHeight(dimension.winheight);
}

useEffect(() => {
    //console.log('resize')
    window.addEventListener('resize', updateDimension)
    if (dimension.winwidth <= 450){
        
        setRowResponsive('column');
        setWidth(400);
        setScale(1);
        setHeightScale(.5)
        setAdonIndent(5)
    } else {
        setMargin(0)
        setRowResponsive('row')
        setWidth(fullWidth)
        setScale(2.1)
        setHeightScale(1)
        setAdonIndent(30)
    }
    return() => {
        window.removeEventListener('resize', updateDimension)
    }
  }, [])

  const [bookID, setBookID] = useState([]); 
  const [firstName, setFirstName] = useState('');
  const [lastName, setLasttName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [email, setEmail] = useState('');
  const [pickupLocation, setPickupLocation] = useState('')
  const [pickupLocationDesc, setPickupLocationDesc] = useState('')
  const [arrivalDate, setArrivalDate] = useState('');
  const [flightModal, setflightModal] = useState(false);
  const [pickupLocModal, setPickupLocModal] = useState(false);
  const [calendarModal, setCalendarModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false); 
  const [flightArrival, setFlightArrival] = useState('');
  const [flightArrivalID, setFlightArrivalID] = useState('');
  const [flightArrivalTime, setFlightArrivalTime] = useState('');

  const [boxColorAirport0, setBoxColorAirport0] = useState(pressedColorAirport)
  const [boxColorAirport1, setBoxColorAirport1] = useState(normalColorAirport)

  const [PayURL,setPayURL] = useState("https://www.southwesttours.info/services/payments/?sid=" + SID)

  const incrementShared = (Increment, Decrement, ServiceTag) => {

    ServiceTag == 'HOHO1' && Increment == 1 && countHOHO1 <= 50 ? setCountHOHO1(countHOHO1 + 1) : ""
    ServiceTag == 'HOHO1' && Decrement == 1 && countHOHO1 >= 1 ? setCountHOHO1(countHOHO1 - 1) : ""
    ServiceTag == 'HOHO2' && Increment == 1 && countHOHO2 <= 50 ? setCountHOHO2(countHOHO2 + 1) : ""
    ServiceTag == 'HOHO2' && Decrement == 1 && countHOHO2 >= 1 ? setCountHOHO2(countHOHO2 - 1) : ""
    ServiceTag == 'HOHO3' && Increment == 1 && countHOHO3 <= 50 ? setCountHOHO3(countHOHO3 + 1) : ""
    ServiceTag == 'HOHO3' && Decrement == 1 && countHOHO3 >= 1 ? setCountHOHO3(countHOHO3 - 1) : ""

}

const computeShared = (ServiceTag) => {
  ServiceTag == 'HOHO1'  ?  setComputeHOHO1(countHOHO1 * priceHOHO1) :
  ServiceTag == 'HOHO2'  ?  setComputeHOHO2(countHOHO2 * priceHOHO2) :
  ServiceTag == 'HOHO3'  ?  setComputeHOHO3(countHOHO3 * priceHOHO3) :
  ServiceTag == 'TelcoSIM1'  ?  setComputeTelcoSIM1(countTelcoSIM1 * telcoSIM1Price) :
  ServiceTag == 'TelcoWIFI'  ?  setComputeTelcoWIFI(countTelcoWIFI * telcoWIFIPrice) :
  ServiceTag == 'sharedC35L'  ?  setComputeC35L(countC35L * priceC35L) : ""

  //console.log('AF :' + computeAF)
}

/* #################   LOAD FLIGHT DETAILS CONTENTS #################### */

const [flights, setFlights] = useState([]);
const displayFlights = '';

const loadFlights = async(type) => {
   // transferTypeFlag == 0 ? 
    const formDataFlight = new FormData();
    formDataFlight.append('method', 'flights')
    formDataFlight.append('P01', airportFlag) //Origin / Airport
    formDataFlight.append('P02', '0') //0 - Arrival 1 - Departure
    
    console.log('airport :' + airportFlag + ' transfer ' + type)
    const resFlight = await fetch('https://www.southwesttours.info/southwest/api/v1/webservices',{method: 'POST', body: formDataFlight})
    try{
        const flightsdata = await resFlight.json()  
        
        setFlights(flightsdata.ResponseData)
            if (flightsdata != null) {
                const displayFlights = flights.map(item => item.FlightNumber) 
                //console.log(displayFlights)
            }
                }catch(err){
        console.error(err)
    }
  }

  function handleFlightDetails(flightID, flightNumber, pickupTIme) {
    console.log(flightID + '-' + flightNumber + '-' + pickupTIme)
    //Arrival
  if (tx == 0) {
    console.log('arrival ' + flightID)
    setFlightArrival(flightNumber);
    setFlightArrivalID(flightID);
    setFlightArrivalTime(pickupTIme);
  }

    //Departure
    if (tx == 1) {
        console.log('departure ' + flightID)
    setFlightDeparture(flightNumber);
    setFlightDepartureID(flightID);
    setFlightDepartureTime(pickupTIme);
    } 
}

const postSale = async() => {

  const formDataHOHO = new FormData();
  formDataHOHO.append('method', 'hoho_sale')
  formDataHOHO.append('P01', pickupLocation) //pickup location
  formDataHOHO.append('P02', countHOHO1 ) //1 day pass tourist
  formDataHOHO.append('P03', countHOHO2 ) //2 day pass tourist
  formDataHOHO.append('P04', countHOHO3 ) //3 day pass tourist
  formDataHOHO.append('P05', '0' ) //15 day pass local
  formDataHOHO.append('P06', '0' ) //30day pass local
  formDataHOHO.append('P07', arrivalDate ) //arrival date
  formDataHOHO.append('P08', flightArrivalID) //arrival flight
  formDataHOHO.append('P09', lastName ) //lastname
  formDataHOHO.append('P10', firstName) //firstname
  formDataHOHO.append('P11', mobileNumber) //mobile numbe
  formDataHOHO.append('P12', email ) //email
  formDataHOHO.append('P13', 'PHP' ) //currency

  console.log("POST SALE" + formDataHOHO.getAll('PO2') + '**');

  const resp = await fetch('https://www.southwesttours.info/southwest/api/v1/webservices',{method: 'POST', body: formDataHOHO})
  try{
      console.log('Fetch')
      const bid = await resp.json()
      bid != null ? setBookingID(bid) : 'No booking ID yet...'  
      setBookingID(bid.ResponseData.BookingId)
      setSID(bid.ResponseData.SID)
      
  }catch(err){
  console.log('ERROR :'+ err)
  }  
}

useEffect(() => {
  console.log('Pickup Loc 1 hoho1 ' +  countHOHO1 + '/hoho2 ' 
  + countHOHO2 + '/hoho3 ' + countHOHO3 + '/ arrival date ' 
  + arrivalDate + '/flight ID ' + flightArrivalID + '/lastname ' 
  + lastName + '/firstname ' + firstName + '/mobile ' + mobileNumber + '/email' + email)

}, [pickupLocModal])



 useEffect(() => {
  console.log('Booking ID:' + bookingID +'---' + SID);
  if (SID != ''){
  setPayURL('https://www.southwesttours.info/services/payments/?sid=' + SID);
    setPaymentModal(true)
    
  }
  }, [SID]) 

  const data2 = [
    {key: '1' , value: 'Caticlan Airport'},
    {key: '2' , value: 'Kalibo Airport'},
    {key: '3' , value: 'Southwest Tours Boracay Sales Office'},
    {key: '4' , value: 'Caticlan Jetty Port or Tabon Port'},
    {key: '5' , value: 'Cagban Port or Tambisaan Port'},
]

const MyContainer = ({classname, children}) => {
    return(
        <View style={{ padding: 16, backgroundColor: 'white', color: "#fff", marginLeft: width == fullWidth ? 20:10 }}>
        <calendarContainer style={{width:300, height: 250}} className={classname}>
        <View style={{width:300 , height: 45, alignItems: 'center', borderColor: borderShade,  padding:10, backgroundColor:'white', borderWidth:0}}><Text style={{color:DARKBLUE, fontSize: width == fullWidth ? fontSizeLargeDesktop: fontSizeLargeMobile, fontWeight:'700'}}>Select Flight Date</Text></View> 
         <View style={{ width:'100%', height:'100%' }}>{children}</View>
        </calendarContainer>
        </View> 
    )
}

function handleFlightDetails(flightID, flightNumber, pickupTIme, ETA, ETD) {
    //console.log(flightID + '-' + flightNumber + '-' + pickupTIme)
    //Arrival
    
    //console.log('HOUR:' + hh + ':' + mm + ' ' + ampm)
  if (tx == 0) {
    const hh = ETA.split(":")[0];
    const mm = ETA.split(":")[1];
    const ampm = ETA.split(" ")[1];
    setFlightArrival(flightNumber + ' ETA(' + hh + ':' + mm + ampm + ')');
    setFlightArrivalID(flightID);
    setFlightArrivalTime(pickupTIme);
    
  }

    //Departure
if (tx == 1) {
    const hh = ETD.split(":")[0];
    const mm = ETD.split(":")[1];
    const ampm = ETD.split(" ")[1];
    //console.log('departure ' + flightID)
    setFlightDeparture(flightNumber + ' ETD(' + hh + ':' + mm + ampm + ')');
    setFlightDepartureID(flightID);
    setFlightDepartureTime(pickupTIme);

    } 
}
    //#########################################################################################################################
    //##################################################   JSX   ##############################################################
    //#########################################################################################################################

  return (
    <View style={{flexDirection:'row', width: width - 10 , height: width > 450 ? 600: 670 , marginLeft:5, borderWidth:2, borderColor: '#707070',  borderRadius:10, padding:20}}>
      
      {/*  //LEFT WINDOW// */}
      <View style={{flexDirection:'column', width:'100%', height:450, alignItems:'center', backgroundColor:'white'}}>
        <View style={{ width:'100%', height:55, flexDirection:'row', fontSize: width > 450 ? fontSizeMediumDesktop: fontSizeMediumMobile}}>
            <View style={{width: '40%', height: rowHeight, borderWidth:0, backgroundColor:'#bfbfff', alignItems:'center', justifyContent:'center'}}><Text>Product</Text></View>
            <View style={{width: '12%', height: rowHeight, borderWidth:0, backgroundColor:'#bfbfff', alignItems:'center', justifyContent:'center'}}><Text>Price</Text></View>
            <View style={{width: '26%', height: rowHeight, borderWidth:0, backgroundColor:'#bfbfff', alignItems:'center', justifyContent:'center'}}><Text>Pcs</Text></View>
            <View style={{width: '22%', height: rowHeight, borderWidth:0, backgroundColor:'#bfbfff', alignItems:'center', justifyContent:'center'}}><Text>Total</Text></View>
            
        </View>
        <View style={{width:'100%', height:rowHeight, flexDirection:'row', fontSize: width > 450 ? fontSizeNormalDesktop: fontSizeNormalMobile}}>
            <View style={{width: '40%', height: rowHeight, borderWidth:1, justifyContent:'center', backgroundColor:'#fff'}}><Text>Hop-on Hop-off 1-Day Pass</Text></View>
            <View style={{width: '12%', height: rowHeight, borderWidth:1, alignItems:'flex-end', padding:8, backgroundColor:'#fff'}}><Text>{priceHOHO1}</Text></View>
            <View style={{flexDirection:'row', width: '26%', height: rowHeight, borderWidth:1, justifyContent:'center', padding:4, backgroundColor:'#fff'}}>
                <TouchableOpacity onPressOut={() => computeShared('HOHO1')} onPressIn={() => incrementShared(0,1, 'HOHO1')} style={MyStyles.incrementBox}>
                    <Ionicons style={{marginTop:0}} name="remove-outline" color="white" size={25} />
                    </TouchableOpacity><Text style={{width: 30, height: 30, padding:5, borderWidth: 1, textAlign:'center'}}>{countHOHO1}</Text>
                    <TouchableOpacity onPressOut={() => computeShared('HOHO1')} onPressIn={() => incrementShared(1,0,'HOHO1')} style={MyStyles.incrementBox}>
                        <Ionicons style={{marginTop:0}} name="add-outline" color="white" size={25} />
                        </TouchableOpacity></View>
            <View style={{width: '22%', height: rowHeight, borderWidth:1, alignItems:'flex-end', padding:8, backgroundColor:'#fff'}}><Text>{computeHOHO1}</Text></View>
            
        </View>
        <View style={{width:'100%', height:rowHeight, flexDirection:'row', fontSize: width > 450 ? fontSizeNormalDesktop: fontSizeNormalMobile}}>
            <View style={{width: '40%', height: rowHeight, borderWidth:1, justifyContent:'center', backgroundColor:'#fff'}}><Text>Hop-on Hop-off 2-Day Pass</Text></View>
            <View style={{width: '12%', height: rowHeight, borderWidth:1, alignItems:'flex-end', padding:8, backgroundColor:'#fff'}}><Text>{priceHOHO2}</Text></View>
            <View style={{flexDirection:'row', width: '26%', height: rowHeight, borderWidth:1, justifyContent:'center', padding:4, backgroundColor:'#fff'}}>
                <TouchableOpacity onPressOut={() => computeShared('HOHO21')} onPressIn={() => incrementShared(0,1, 'HOHO2')} style={MyStyles.incrementBox}>
                    <Ionicons style={{marginTop:0}} name="remove-outline" color="white" size={25} />
                    </TouchableOpacity><Text style={{width: 30, height: 30, padding:5, borderWidth: 1, textAlign:'center'}}>{countHOHO2}</Text>
                    <TouchableOpacity onPressOut={() => computeShared('HOHO2')} onPressIn={() => incrementShared(1,0,'HOHO2')} style={MyStyles.incrementBox}>
                    <Ionicons style={{marginTop:0}} name="add-outline" color="white" size={25} />
                    </TouchableOpacity></View>
            <View style={{width: '22%', height: rowHeight, borderWidth:1, alignItems:'flex-end', padding:8, backgroundColor:'#fff'}}><Text>{computeHOHO2}</Text></View>
            
        </View>

        <View style={{width:'100%', height:55, flexDirection:'row', fontSize: width > 450 ? fontSizeNormalDesktop: fontSizeNormalMobile}}>
            <View style={{width: '40%', height: rowHeight, borderWidth:1, justifyContent:'center', backgroundColor:'#fff'}}><Text>Hop-on Hop-off 3-Day Pass</Text></View>
            <View style={{width: '12%', height: rowHeight, borderWidth:1, alignItems:'flex-end', padding:8, backgroundColor:'#fff'}}><Text>{priceHOHO3}</Text></View>
            <View style={{flexDirection:'row', width: '26%', height: rowHeight, borderWidth:1, justifyContent:'center', padding:4, backgroundColor:'#fff'}}>
                <TouchableOpacity onPressOut={() => computeShared('HOHO3')} onPressIn={() => incrementShared(0,1, 'HOHO3')} style={MyStyles.incrementBox}>
                    <Ionicons style={{marginTop:0}} name="remove-outline" color="white" size={25} />
                </TouchableOpacity><Text style={{width: 30, height: 30, padding:5, borderWidth: 1, textAlign:'center'}}>{countHOHO3}</Text>
                <TouchableOpacity onPressOut={() => computeShared('HOHO3')} onPressIn={() => incrementShared(1,0,'HOHO3')} style={MyStyles.incrementBox}>
                    <Ionicons style={{marginTop:0}} name="add-outline" color="white" size={25} />
                </TouchableOpacity></View>
            <View style={{width: '22%', height: rowHeight, borderWidth:1, alignItems:'flex-end', padding:8, backgroundColor:'#fff'}}><Text>{computeHOHO3}</Text></View>
            
        </View>
        <View style={{width:'100%', height:100, flexDirection:'row'}}>
            <View style={{flexDirection:'column', width:'45%', height:100}}>
                <View style={{width: '100%', height: rowHeight, borderWidth:0, padding:0, fontSize: width > 450 ? fontSizeNormalDesktop: fontSizeNormalMobile, backgroundColor:'#fff'}}><TouchableOpacity onPress={() => setPickupLocModal(true)} style={{width:'455', height:rowHeight, padding:8, borderRadius:5, alignItems:'center', backgroundColor:'orange'}}><Text style={{color:'white', fontWeight:'bold'}}>Select Pickup Location</Text></TouchableOpacity></View>
                <View style={{width: '100%', height: 60, borderWidth:0}}>
                { pickupLocation == 1 || pickupLocation == 2 ?
                    <View style={{width:'100%', height:40}}>
                        <View style={{width:'100%', height: 30, alignItems:'center'}}><Text >Select FLight Detials</Text></View>
                        <View style={{flexDirection:'row', padding: 0, width: '100%', alignItems:'space-between', backgroundColor:'white', height: 80}}>
                            <View style={{flexDirection:'row', width: 160, marginTop:-10, height: 30, alignItems:'center', backgroundColor:'white'}}>
                                    <TextInput placeholder='Arrival Date' name='Box01' value={arrivalDate} style={{width: 120, height: 30, borderRadius: 5, borderWidth: 1}}></TextInput>
                                    <TouchableOpacity onPress={() => {setCalendarModal(true)}} style={MyStyles.incrementBox}><Ionicons style={{marginTop:-5}} name="calendar" color="white" size={25} /></TouchableOpacity><TouchableOpacity style={{width:50, height:50}}></TouchableOpacity>
                            </View> 
                            <View style={{flexDirection:'row', width: 160, marginTop:-10, height: 30, backgroundColor:'#fff'}}>
                                <TextInput placeholder='Flight details' name='Box02' value={flightArrival} style={{width: 120, height: 30,borderRadius: 5,borderWidth: 1}}></TextInput><TouchableOpacity onPress={() => {setflightModal(true);setTx(0); loadFlights(0)}} style={MyStyles.incrementBox}><Ionicons style={{marginTop:0}} name="airplane" color="white" size={25} /></TouchableOpacity><TouchableOpacity style={{width:50, height:50}}></TouchableOpacity>
                            </View> 
                        </View>
                    </View> : <View><Text></Text></View>
                    }
                </View>
            </View>
            <View style={{width: '45%', height: rowHeight *2, borderWidth:0, paddingLeft:20, color: 'gray', fontSize: width > 450 ? fontSizeMediumDesktop: fontSizeMediumMobile, alignItems:'flex-start', backgroundColor:'#fff'}}><Text style={{fontWeight:'500', fontSize: width > 450 ? fontSizeNormalDesktop: fontSizeMediumMobile}}>Pickup Location : {'\n'}</Text><Text style={{color: ORANGE, fontWeight:'700'}}>{pickupLocationDesc}</Text></View>
            
           

        </View>
        {/* ############################# G U E S T   I N F O   B O X  #################################### */}
            
            <View style={{flexDirection:'column', width: width - 40, padding:10, marginTop:10, height: width > 450 ? 180: 265, borderWidth:1, borderRadius:10, backgroundColor:'white'}}>
                  <Text  style={{width:'100%', height: 50}}>Guest Information</Text>
                  <View style={{flexDirection: width == fullWidth ? 'row':'column'}}>

                    <View style={{flexDirection:'column', width:'50%', height:'50%'}}>
                            <View style={{flexDirection:'row', width:'100%', height:40}}>
                                <Text style={{width:80, height: 40}}>Lastname</Text>
                                <TextInput  onChangeText={(lastname) => setLasttName(lastname)} style={{width:200, height: 40, borderRadius: 5, borderWidth: 0.5}}></TextInput>
                                
                            </View>   
                            <View style={{flexDirection:'row', width:'100%', height:40}}>
                            <Text style={{width:80, height: 40, marginTop:5, marginLeft:0}}>Firstname</Text>
                                <TextInput onChangeText={(firstname) => setFirstName(firstname)} style={{width:200, height: 40, marginTop:10, borderRadius: 5,  borderWidth: 0.5, marginLeft:0}}></TextInput>
                            </View>  
                    </View>

                    <View style={{flexDirection:'column', width:'50%', height:'50%', marginTop: width== fullWidth ? 0:15}}>
                            <View style={{flexDirection:'row', width:'100%', marginTop: 0, height:40}}>
                                <Text style={{width:120, height: 40}}>Mobile Number</Text>
                                <TextInput name='Box3' keyboardType='number-pad' onChangeText={(mobile) => setMobileNumber(mobile)} style={{width:200, marginLeft:12, height: 40, borderRadius: 5, borderWidth: 0.5}}></TextInput>
                            </View>       
                            <View style={{flexDirection:'row', width:'100%', marginTop: 5, height:40}}>
                                <Text style={{width:120, height: 40}}>Email Address</Text>
                                <TextInput  keyboardType='email-address' onChangeText={(email) => setEmail(email)} style={{width:200, marginLeft:12, height: 40, marginTop:5, borderRadius: 5, borderWidth: 0.5}}></TextInput>
                                
                            </View> 
                        </View>
                    </View>
                </View>
              
            <View style={{ width: '100%', marginTop:10, height: 45, alignItems:'center', justifyContent:'space-around', backgroundColor:'white'}}>
                 <TouchableOpacity onPress={()=> {postSale()}} style={{width:230, height:45, padding:12,borderRadius:5, backgroundColor:'orange'}}><Text style={{alignSelf:'center', color:'white', fontWeight:'bold'}}>Checkout</Text></TouchableOpacity>
           </View>

    </View>

    {/* **************** M O D A L S ***************** */}
 
                    {/* ***************M O D A L   F L I G H T   P I C K E R*************** */}
                    <View style={MyStyles.centeredView}>
                        <Modal
                            animationType="fade"
                            transparent={true}
                            visible={flightModal}
                            onRequestClose={() => {
                            setflightModal(false);
                            }}>
                            <View style={MyStyles.centeredView}>
                                <View style={width == fullWidth ? MyStyles2.modalView : MyStyles.modalView}>

                                <View style={{width:'100%', height:'100%', marginLeft:15, backgroundColor:'white'}}>
                                <View style={{width:'100%', height: 45, alignItems:'center', borderColor: borderShade,  padding:10, backgroundColor:'white', borderWidth:0}}><Text style={{color:DARKBLUE, fontSize:20, fontWeight:'700'}}>Select Pickup Location</Text></View> 
                                
                                <View style={{flexDirection:'row', width:'100%', height:30, color:'gray', fontSize: fontSizeMediumMobile}}>
                                    <View style={{width:'50%', height:30}}><Text>Flight Number</Text></View>
                                    <View style={{width:'25%', height:30}}><Text>Flight Time</Text></View>
                                    <View style={{width:'25%', height:30}}><Text>Flight Time</Text></View>
                                </View>
                                <FlatList
                                    style={{backgroundColor:'white'}}
                                    data={flights}
                                    keyExtractor={item => item.FlightId}
                                    renderItem={({item})=>(
                                    <View style={{flexDirection:'column', width:'90%', alignItems:'center', height:40}}>
                                        <View style={{flexDirection:'row', width:'100%', height:40}}>
                                            <View style={{width:'50%', height:35, marginLeft:20}}><Text style={{color:textColor}}> {item.FlightNumber}</Text></View>
                                            <View style={{width:'25%', height:35}}><Text style={{color:textColor}}> {tx == 0 ? item.ETA:item.ETD}</Text></View>
                                            <View style={{width:'25%', height:35, alignItems:'center', marginLeft:-10}}><TouchableOpacity value={item.FlightId} onPress={() => {handleFlightDetails(item.FlightId, item.FlightNumber, item.HotelPickupTime, item.ETA, item.ETD); setflightModal(false)}} style={MyStyles.addtocartBox}><Ionicons style={{marginTop:0}} name="chevron-forward-outline" color={iconColor} size={25}  /></TouchableOpacity></View>
                                       
                                        </View>
                                    </View>
                                )}
                                />
                            <View style={{width:'100%',height:30, alignItems:'center', backgroundColor:'white'}}>
                                <TouchableOpacity onPress={()=> {postSale(); setflightModal(false)}} style={{width:150, height:35, padding:10, marginTop:0, borderRadius:10, backgroundColor:'orange'}}><Text style={{alignSelf:'center', color:'black', fontWeight:'normal'}}>Close</Text></TouchableOpacity>
                                   {/*  <TouchableOpacity onPress={()=> postSale()} style={{width:150, height:35, padding:10, marginTop:5, borderRadius:10, backgroundColor:'orange'}}><Text style={{alignSelf:'center', color:'black', fontWeight:'normal'}}>Close</Text></TouchableOpacity> */}
                                </View>
                                </View>
                                </View>

                            </View>
                        </Modal>
                    </View>

           {/* *************** M O D A L  S E L E C T   P I C K U P   L O C A T I O N  *************** */}
           <View style={MyStyles.centeredView}>
                        <Modal
                            animationType="fade"
                            transparent={true}
                            visible={pickupLocModal}
                            onRequestClose={() => {
                            setPickupLocModal(false);
                            }}>

                            <View style={MyStyles.centeredView}>
                                <View style={width == fullWidth ? MyStyles2.modalView : MyStyles.modalView}>
                                <View style={{width:'90%', height: 45, alignItems:'center', borderColor: borderShade,  padding:10, backgroundColor:'white', borderWidth:0}}><Text style={{color:DARKBLUE, fontSize:20, fontWeight:'700'}}>Select Pickup Location</Text></View> 
                                
                                    <View style={{width: width == fullWidth ? 500 : 350, marginTop: 20}}>
                                        <SafeAreaView style={{ flex: 1 }}>
                                        <FlatList
                                                style={{backgroundColor:'white'}}
                                                data={data2}
                                                keyExtractor={item => item.FlightId}
                                                renderItem={({item})=>(
                                            
                                                <View style={{flexDirection:'column', width:'100%', height:45}}>
                                                
                                                    <View style={{flexDirection:'row', width:'100%', height:45}}>
                                                        
                                                        <View style={{width:'90%', height:45}}><Text>{item.value}</Text></View>
                                                        <View style={{width:'10%', height:45}}><TouchableOpacity key={item.key} value={item.key} onPress={() => {setPickupLocation(item.key);setPickupLocationDesc(item.value), setPickupLocModal(false)}} style={{width: 50, height: 40, borderRadius:10, backgroundColor:DARKBLUE}}><Ionicons style={{marginTop:0}} name="chevron-forward-outline" color="white" size={30}  /></TouchableOpacity></View>
                                                        
                                                    </View>
                                                </View>
                                            
                                            )}
                                            />
                                        </SafeAreaView>
                                    </View>
                            <View style={{width:'100%',height:50, alignItems:'center', marginTop:20, backgroundColor:'white'}}>
                                       <TouchableOpacity onPress={()=> setPickupLocModal(false)} style={{width:150, height:40, padding:10, borderRadius:10, backgroundColor:'orange'}}><Text style={{alignSelf:'center', color:'white', fontWeight:'bold'}}>Close</Text></TouchableOpacity>
                            </View>
                                </View>
                            </View>
                        </Modal>
                    </View>

         {/* *************** M O D A L   C A L E N D A R *************** */}
        <View style={MyStyles.centeredView}>
                        <Modal
                            animationType="fade"
                            transparent={true}
                            visible={calendarModal}
                            onRequestClose={() => {
                            setCalendarModal(false);
                            }}>

                            <View style={MyStyles.centeredView}>
                                <View style={width == fullWidth ? MyStyles2.modalCalendar : MyStyles.modalCalendar}>

                                <DatePicker style={{marginLeft:0}}
                                    calendarContainer={MyContainer} selected={today} 
                                        onChange={(date) => {
                                                                                  
                                            moment(date,'YYYY-MM-DD').isAfter(moment(today,'YYYY-MM-DD')) ? setArrivalDate(moment(date,'YYYY-MM-DD').format('YYYY-MM-DD')) : transferTypeFlag == 0 && dateFlag == 0 ? alert('You selected Arrival Date is earlier than the current date'): '';
                                            setCalendarModal(false) ; 
                                             
                                
                                    }}
                                       
                                    />                               
                                </View>
                            </View>
                        </Modal>
                    </View>

                                  {/* *************** M O D A L  P A Y M E N T    *************** */}
                   <View style={MyStyles.centeredView}>
                        <Modal
                            animationType="fade"
                            transparent={true}
                            visible={paymentModal}
                            onRequestClose={() => {
                            setPaymentModal(false);
                            }}>

                            <View style={MyStyles.centeredView}>
                                <View style={width == fullWidth ? MyStyles2.modalViewBig : MyStyles.modalViewBig}>
                            <SafeAreaView style={{ flex: 1 }}>
                            <iframe src={PayURL} height={'100%'} width={width == fullWidth ? 600:350} />
                            </SafeAreaView>
                            <View style={{width:'100%',height:50, alignItems:'center', backgroundColor:'white'}}>
                                       <TouchableOpacity onPress={()=> setPaymentModal(false)} style={{width:150, height:40, padding:15, borderRadius:'10', marginTop:10, backgroundColor:'orange'}}><Text style={{alignSelf:'center', color:'white', fontWeight:'bold'}}>Close</Text></TouchableOpacity>
                            </View>
                                </View>
                            </View>
                        </Modal>
                    </View>

  </View>
  )
}



